import { DateInput, DateInputProps } from "@mantine/dates"
import { DateOnly } from "../../@client/System"

interface Props extends Omit<
  DateInputProps,
  "value" | "onChange" | "minDate" | "maxDate"
> {
  value: DateOnly | null
  onChange: (date: DateOnly | null) => void
  minDate?: DateOnly | null
  maxDate?: DateOnly | null
}

export function DateOnlyInput({
  value,
  onChange,
  minDate,
  maxDate,
  ...props
}: Props) {
  const handleChange = (date: string | null) => {
    if (date) {
      const dateOnlyValue = getDateOnly(date)
      onChange(dateOnlyValue)
    } else {
      onChange(null)
    }
  }

  return (
    <DateInput
      minDate={minDate ? new Date(minDate) : undefined}
      maxDate={maxDate ? new Date(maxDate) : undefined}
      value={value ? new Date(value) : null}
      onChange={handleChange}
      valueFormat="L"
      {...props}
    />
  )
}

function getDateOnly(timeStamp: string | Date) {
  const date = new Date(timeStamp)
  const year = date.getFullYear()
  const month = (date.getMonth() + 1).toString().padStart(2, "0")
  const day = date.getDate().toString().padStart(2, "0")
  return `${year}-${month}-${day}` as DateOnly
}
